export class ReceptionEditorInstantCloserSetting {
  isEnable: boolean;
  waitTimeAsMilliSeconds: number;
  shouldShowNotification: boolean;
}
